export var SubEntityType = {
    Applications: 'applications',
    BluetoothPairingGuides: 'bluetoothpairingguides',
    Documents: 'documents',
    FrequentlyAskedQuestions: 'frequentlyaskedquestions',
    SerialNumberLocators: 'serialnumberlocators',
    Software: 'software',
    Videos: 'videos',
};
